import {
    createSkyNetObjectRoutes,
} from 'app/shared-components/SkyNetObjectProfile/SkyNetObjectRoutes.utils'

import ContractBasisDemoPage from './ContractBasisDemoPage'
import domainConfig from './ContractBasisDemo.config'

export default createSkyNetObjectRoutes(<ContractBasisDemoPage />, domainConfig)
